import { AddToCartTransfers } from "./AddToCartTransfers";
import { TransfersPricing } from "./TransfersPricing";
import { SaveOptionsSection } from "./SaveOptionsSection";
import type { TransfersFooterProps } from "../types";

export function TransfersFooter({
  unitPrice,
  totalPrice,
  quantity,
  showSaveOptions = true,
  preCutPrice = 0.3,
  onPreCutToggle,
  isPreCutEnabled = false,
  onAddToCart,
  isAddingToCart = false,
  isAddToCartDisabled = false
}: TransfersFooterProps) {
  return (
    <footer className="drop-shadow-top flex w-full items-center justify-end gap-6 rounded-t-2xl bg-white px-8 py-4">
      {/* Save Options Section - positioned center-right */}
      {showSaveOptions && (
        <SaveOptionsSection
          preCutPrice={preCutPrice}
          isEnabled={isPreCutEnabled}
          onToggle={onPreCutToggle}
        />
      )}

      {/* Pricing Section */}
      <TransfersPricing unitPrice={unitPrice} totalPrice={totalPrice} quantity={quantity} />

      {/* Add to Cart Button */}
      <AddToCartTransfers
        onAddToCart={onAddToCart}
        isLoading={isAddingToCart}
        isDisabled={isAddToCartDisabled}
      />
    </footer>
  );
}
